import { Fragment } from "react";
import { AnalyticsEmptyFilteredState } from "./AnalyticsEmptyFilteredState";
import { AnalyticsWidgetUiDetailsDto } from "../../types/analytics";
import AnalyticsFilterInputs from "../../types/analytics/AnalyticsFilterInputs";
import { AnalyticsPageWidgetSummary } from "../../types/analytics/AnalyticsWidgetUiDetailsDto";
import { GroupedJourneys } from "../../types/analytics/FilterAvailableValues";
import AnalyticsWidget from "./AnalyticsWidget";

interface AnalyticsWidgetCollectionProps {
  widgets: AnalyticsWidgetUiDetailsDto[];
  filters: AnalyticsFilterInputs;
  journeys: GroupedJourneys[];
  dynamicPageId?: number | undefined;
  onRequestOtherWidgetRefresh?: (
    dynamicWidgetId: number,
    onSuccess: () => void,
    onError: () => void
  ) => void;
  afterFirstWidget?: React.ReactNode;
}

function AnalyticsWidgetCollection({
  widgets,
  filters,
  journeys,
  dynamicPageId,
  onRequestOtherWidgetRefresh,
  afterFirstWidget,
}: AnalyticsWidgetCollectionProps) {
  if (!widgets || widgets.length === 0) {
    return <AnalyticsEmptyFilteredState />;
  }

  const pageWidgets: AnalyticsPageWidgetSummary[] = widgets.map((widget) => ({
    widgetId: widget.widgetId,
    dynamicWidgetId: widget.dynamicWidgetId,
    displayType: widget.displayType,
  }));

  return (
    <div>
      {widgets.map((widget, index) => (
        <Fragment key={widget.widgetId}>
          <AnalyticsWidget
            widgetDetails={widget}
            filters={filters}
            journeys={journeys}
            dynamicPageId={dynamicPageId}
            allWidgetsForPage={pageWidgets}
            onRequestOtherWidgetRefresh={onRequestOtherWidgetRefresh}
          />
          {index === 0 && afterFirstWidget}
        </Fragment>
      ))}
    </div>
  );
}

export default AnalyticsWidgetCollection;
